/**
 * Convierte el reason de captureGpsDetailed a un mensaje legible para el técnico.
 * Frame legal: "visita", "ubicación", "en sitio".
 *
 * @param {'unsupported'|'denied'|'unavailable'|'timeout'|'error'|null} reason
 * @returns {string}
 */
export function gpsReasonMessage(reason) {
  switch (reason) {
    case 'unsupported':
      return 'Tu navegador no permite ubicación (¿estás en una conexión segura/HTTPS?).';
    case 'denied':
      return 'Permiso de ubicación denegado. Activalo en el navegador y reintentá.';
    case 'unavailable':
      return 'Ubicación no disponible (sin señal).';
    case 'timeout':
      return 'Tardó demasiado obteniendo la ubicación. Reintentá.';
    default:
      return 'No se pudo obtener la ubicación.';
  }
}
